import { Component } from '@angular/core';

@Component({
    selector: 'bb-product-items-page-ui',
    templateUrl: './bb-product-items-page-ui.component.html',
    standalone: false,
})
export class ProductItemsPageComponent {}
